var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Avatar"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_439_242",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 45,
    height: 45
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_439_242)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval",
    d: "M22.5 45C34.9264 45 45 34.9264 45 22.5C45 10.0736 34.9264 0 22.5 0C10.0736 0 0 10.0736 0 22.5C0 34.9264 10.0736 45 22.5 45Z",
    fill: "#1A8DE6",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    d: "M22.5 22.5C27.4706 22.5 31.5 18.4706 31.5 13.5C31.5 8.52944 27.4706 4.5 22.5 4.5C17.5294 4.5 13.5 8.52944 13.5 13.5C13.5 18.4706 17.5294 22.5 22.5 22.5Z",
    fill: "#1A8DE6",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval_3",
    d: "M22.5 63C33.0624 63 41.625 54.4374 41.625 43.875C41.625 33.3126 33.0624 24.75 22.5 24.75C11.9376 24.75 3.375 33.3126 3.375 43.875C3.375 54.4374 11.9376 63 22.5 63Z",
    fill: "#1A8DE6",
    fillOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.1e69505063445a55ecfd1f703d9212ab.svg";
export { ForwardRef as ReactComponent };